import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiFileText, FiCreditCard } from 'react-icons/fi';
import FormLayout, { SubmitBtn } from '../../ui/FormLayout';
import { InputField, CheckField } from '../../ui/InputField';

const CadastrarFormaPagamento = () => {
    const [descricao, setDescricao] = useState('');
    const [parcelamento, setParcelamento] = useState(false);
    const navigate = useNavigate();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    const handleSubmit = () => {
        if (descricao !== '') {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
                body: JSON.stringify({ "descricao": descricao, "parcelamento": parcelamento === true ? 1 : 0 })
            };
            fetch(Apis.urlCadastrarFormaPagamento, requestOptions)
                .then(response => response.json())
                .then((result) => {
                    if (result.retorno.sucesso) {
                        navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-forma-pagamento`);
                    } else {
                        alertaErro(result.retorno.mensagem);
                    }
                });
        } else {
            alertaErro('O campo descrição é obrigatório.');
        }
    };

    return (
        <FormLayout
            title="Cadastro de Forma de Pagamento"
            icon={<FiCreditCard />}
            subtitle="Informe os dados da forma de pagamento."
        >
            <InputField
                label="Descrição" icon={<FiFileText />} required
                placeholder="Ex: Dinheiro, Cartão de Crédito"
                onChange={e => setDescricao(e.target.value)} value={descricao}
            />
            <CheckField
                label="Permitir Parcelamento no Pedido"
                checked={parcelamento}
                onChange={setParcelamento}
            />
            <SubmitBtn onClick={handleSubmit}>Cadastrar</SubmitBtn>
        </FormLayout>
    );
};

export default CadastrarFormaPagamento;
